/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Format_On_PasteInputs */



/**
* | output |
* | --- |
* | "Auto-Format Text on Paste" |
*
* @param {Options_Editor_Auto_Format_On_PasteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_format_on_paste = /** @type {((inputs?: Options_Editor_Auto_Format_On_PasteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Format_On_PasteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formater automatiquement le texte lors du collage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text beim Einfügen automatisch formatieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formattazione automatica del testo durante l'incollaggio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое форматирование текста при вставке")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato automático de texto al pegar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("粘贴时自动格式化文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("貼り付け時にテキストを自動フォーマットする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पेस्ट करने पर टेक्स्ट को ऑटो-फॉर्मेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação automática de texto ao colar")
	return /** @type {LocalizedString} */ ("Auto-Format Text on Paste")
});